// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 开发票 POST /invoice */
export async function invoiceUsingPOST(
  body: API.ApplyOrderInvoiceReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/invoice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取发票 GET /invoice/${param0} */
export async function invoiceOrderNumberUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.invoiceOrderNumberUsingGETParams,
  options?: { [key: string]: any },
) {
  const { orderNumber: param0, ...queryParams } = params;
  return request<API.BaseResultListGetInvoiceResp>(`/invoice/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量获取发票 POST /invoice/batch */
export async function invoiceBatchUsingPOST(
  body: API.BatchReqstring,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMapint>('/invoice/batch', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
